import {
  OEButton,
  OEText,
  OEModal,
  flex,
  mr,
  mb,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { View } from 'react-native';

interface ActiveClassCardModalProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isActive?: boolean;
}
export const ActiveClassCardModal = ({
  isVisible,
  onClose,
  isActive,
  onConfirm,
}: ActiveClassCardModalProps) => {
  return (
    <Container onClose={onClose} visible={isVisible}>
      <OEText fontType="bold" fontSize={20}>
        Confirm
      </OEText>

      <OEText style={[mb(12)]}>
        {isActive
          ? 'Are you sure you want to cancel classes for today?'
          : 'Are you sure you want to start classes for today?'}
      </OEText>
      <View style={flex('flex-row', 'justify-content-end')}>
        <OEButton style={mr(12)} onPress={onClose}>
          Cancel
        </OEButton>
        <OEButton onPress={onConfirm}>Confirm</OEButton>
      </View>
    </Container>
  );
};

const Container = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;
